module.exports = __webpack_public_path__ + "img/mauritania-logo-icon.f64fb6c8.png";